import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private dom: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    const decodedValue = value ? this.decodeHtml(value) : '';
    return this.dom.bypassSecurityTrustHtml(decodedValue);
  }
  private decodeHtml(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }
}
